import { useParams } from 'react-router-dom';

import { AppCreateLinkPage } from '~/components/pages/AppCreateLinkPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { useNavigate } from '~/components/utils/Navigation';

export const AppCreateLinkRoute: React.FC = () => {
  const { appId, categoryId } = useParams();
  const navigate = useNavigate();

  if (!appId) {
    navigate('/');

    return null;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppCreateLinkPage appId={appId} parentCategoryId={categoryId} />
    </DashboardTemplate>
  );
};
